import { FC, ReactNode } from 'react';

import { Flex, StyleProps, Text } from '@bonusly/design-system';

interface Props extends StyleProps {
	label: ReactNode;
	subLabel?: string;
}

export const MenuItemInformation: FC<Props> = ({ label, subLabel }: Props) => (
	<Flex direction="column" flex={1} justifyContent="center" minWidth={0}>
		<Text fontSize="lg" fontWeight={500} lineHeight={5} overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
			{label}
		</Text>

		{subLabel && (
			<Text color="gray.600" fontSize="sm" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
				{subLabel}
			</Text>
		)}
	</Flex>
);
